<div class="page-layout w75 p-24 bg-white" fusePerfectScrollbar>
  <div class="white-box">
    <div class="boxBody">
      <div class="tabWraper">
        <div class="actWraper mb-4" fxLayout="column" fxLayout.gt-sm="row" fxFlex="100">
          <button mat-raised-button color="accent" (click)="CreateStripeTransaction()">Create Stripe Transaction</button>
          <button mat-raised-button color="accent" class="ml-12" (click)="searchStripeTransaction()">Search Stripe Transaction</button>
        </div>
      </div>
    </div>
  </div>
</div>